const Flickity = require('flickity');
export function archiveCarousel() {
  const carouselContainer = document.querySelectorAll('.js-archive-carousel-container');
  if(carouselContainer) {
    for (let i = 0; i < carouselContainer.length; i++) {
      const _carouselContainer = carouselContainer[i];
      const carousel = _carouselContainer.querySelector('.js-archive-carousel');
      const prev = _carouselContainer.querySelector('.js-carousel-prev');
      const next = _carouselContainer.querySelector('.js-carousel-next');
      const carouselCount = _carouselContainer.querySelector('.js-carousel-count');
      if(carousel) {
        const flkty = new Flickity(carousel, {
          cellSelector: '.js-carousel-cell',
          cellAlign: 'center',
          wrapAround: true,
          groupCells: false,
          setGallerySize: true,
          prevNextButtons: false,
          pageDots: true,
          pauseAutoPlayOnHover: false
        });
        if(prev){
          prev.addEventListener('click', (e) => {
            flkty.previous();
            e.preventDefault();
          });
        }
        if(next){
          next.addEventListener('click', (e) => {
            flkty.next();
            e.preventDefault();
          });
        }
        if(carouselCount) {
          flkty.on('change', (index) => {
            carouselCount.innerHTML = index+1;
          });
        }
      }
    }
  }
}